import { useEffect, useState } from "react";
import "./css/index.css";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import { Provider, useDispatch, useSelector } from "react-redux";
import store from "./store";
import WebRoutes from "./routes/web";
import AdminRoutes from "./routes/admin";
import apiRequest, {
  instance,
  setLogoutFunction,
  setupInterceptors,
} from "./utils/apiRequest";
import { setSiteSetting } from "./store/slice/globalStore";
import Loader from "./components/ui/loader/Loader";
import { Helmet } from "react-helmet";
import { getFileUrl } from "./utils/helper";
import { AuthProvider } from "./context/AuthContext";
import ScrollToTop from "./pages/web/ScrollToTop";


function App() {
  return (
    <>
      <Toaster position="top-right" />
        <Routes>
          <Route path="/admin/*" element={<AdminRoutes />} />
          <Route path="/*" element={<WebRoutes />} />
        </Routes>
    </>
  );
}

function AppInitializer() {
  const setting = useSelector((state) => state.globalState.siteSetting);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiRequest
      .getSetting()
      .then((data) => {
        console.log(data);
        dispatch(setSiteSetting(data.data));
      })
      .catch((error) => {
        console.error("Failed to load site settings:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  if (loading) return <Loader />;

  return (
    <BrowserRouter>
    <ScrollToTop/>
      <Helmet>
        <title>{setting?.site_settings?.site_name}</title>
        <link
          rel="icon"
          href={getFileUrl(setting?.site_settings?.site_favicon, "settings")}
        />
        <link
          rel="apple-touch-icon"
          href={getFileUrl(setting?.site_settings?.site_logo, "settings")}
        />
      </Helmet>

      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  );
}

// Render root
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <AppInitializer />
  </Provider>
);
